/* ==========================================================================
   HerLoom Style ID — salon entrance + quiz + paid result engine
   --------------------------------------------------------------------------
   No AI, no database. This file is the interpreter and the interface; every
   rule table and every line of advice lives in herloom-style-id-engine.js,
   which is generated from the engine spec. Change copy there, not here.

   Answer model: 11 questions. The first ten are the spec's; `time` is ours
   and only ever changes how much of the routine is shown — never the heat,
   the section size or the zones.

   Safety order, applied once and never re-opened:
     1. condition hard cap · 2. chemical hard cap · 3. heat concern
     4. thickness · 5. pattern · 6. goal · 7. speed

   Hair colour is identity, not a damage score. It never touches the settings.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'herloom_style_id_v2';
  var ENGINE = window.HSID_ENGINE;

  /* ------------------------------------------------------------------ */
  /* Icons                                                               */
  /* ------------------------------------------------------------------ */

  var S = function (d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  };

  var ICONS = {
    lock: S('<rect x="4.5" y="10.5" width="15" height="10" rx="2.2"/><path d="M8.2 10.5V7.8a3.8 3.8 0 0 1 7.6 0v2.7"/>'),
    help: S('<circle cx="12" cy="12" r="9"/><path d="M9.2 9.3a2.9 2.9 0 1 1 3.6 3.4c-.6.3-.8.7-.8 1.3v.4"/><path d="M12 17.4h.01"/>'),
    curl: S('<path d="M6 3c0 3 4 3 4 6s-4 3-4 6 4 3 4 6"/><path d="M15 3c0 3 4 3 4 6s-4 3-4 6 4 3 4 6"/>'),
    curlTight: S('<path d="M7 3c-3 1.5-3 4 0 5.5s3 4 0 5.5-3 4 0 5.5"/><path d="M14 3c-3 1.5-3 4 0 5.5s3 4 0 5.5-3 4 0 5.5"/><path d="M20 6v12"/>'),
    wave: S('<path d="M3 8c2-3 4-3 6 0s4 3 6 0 4-3 6 0"/><path d="M3 16c2-3 4-3 6 0s4 3 6 0 4-3 6 0"/>'),
    straight: S('<path d="M6 3v18"/><path d="M12 3v18"/><path d="M18 3v18"/>'),
    coil: S('<path d="M8 3c-3 2-3 5 0 6s3 4 0 6 -3 5 0 6"/><path d="M17 3c-3 2-3 5 0 6s3 4 0 6 -3 5 0 6"/>'),
    volume: S('<path d="M12 21V9"/><path d="M5 12c0-5 3-9 7-9s7 4 7 9"/><path d="M8 21c0-4 1-7 4-7s4 3 4 7"/>'),
    root: S('<path d="M4 6h16"/><path d="M8 6c0 4-1 7-3 9"/><path d="M12 6v12"/><path d="M16 6c0 4 1 7 3 9"/>'),
    sleek: S('<path d="M5 4h14"/><path d="M7 9h10"/><path d="M9 14h6"/><path d="M11 19h2"/>'),
    clock: S('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
    bolt: S('<path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/>'),
    strandFine: S('<path d="M12 3v18"/>'),
    strandMedium: S('<path d="M9 3v18"/><path d="M15 3v18"/>'),
    strandThick: S('<path d="M7 3v18"/><path d="M12 3v18"/><path d="M17 3v18"/><path d="M4 3v18" opacity=".4"/><path d="M20 3v18" opacity=".4"/>'),
    densityLow: S('<circle cx="8" cy="8" r="1.6"/><circle cx="16" cy="16" r="1.6"/>'),
    densityMed: S('<circle cx="7" cy="7" r="1.6"/><circle cx="17" cy="7" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="7" cy="17" r="1.6"/>'),
    densityHigh: S('<circle cx="6" cy="6" r="1.4"/><circle cx="12" cy="6" r="1.4"/><circle cx="18" cy="6" r="1.4"/><circle cx="6" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="18" cy="12" r="1.4"/><circle cx="6" cy="18" r="1.4"/><circle cx="12" cy="18" r="1.4"/><circle cx="18" cy="18" r="1.4"/>'),
    lenShort: S('<circle cx="12" cy="6" r="3"/><path d="M7 21c0-5 2-8 5-8s5 3 5 8"/><path d="M8 13h8"/>'),
    lenMid: S('<circle cx="12" cy="5" r="3"/><path d="M6 21c0-7 2-11 6-11s6 4 6 11"/>'),
    lenLong: S('<circle cx="12" cy="4.5" r="2.8"/><path d="M5 22c0-9 3-13 7-13s7 4 7 13"/>'),
    lenVeryLong: S('<circle cx="12" cy="3.6" r="2.4"/><path d="M4 23c0-11 3.5-16 8-16s8 5 8 16"/><path d="M8 18h8"/>'),
    leaf: S('<path d="M20 4C10 4 4 9 4 17v3h3c8 0 13-6 13-16z"/><path d="M4 20c4-6 8-9 13-11"/>'),
    palette: S('<circle cx="12" cy="12" r="9"/><circle cx="9" cy="9.5" r="1"/><circle cx="15" cy="9.5" r="1"/><circle cx="9.5" cy="15" r="1"/>'),
    shield: S('<path d="M12 3l7 3v6c0 5-3 8-7 9-4-1-7-4-7-9V6z"/><path d="M9 12l2 2 4-4"/>'),
    flask: S('<path d="M10 3h4"/><path d="M11 3v6L5 19a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-6-10V3"/>'),
    layers: S('<path d="M12 3 3 8l9 5 9-5-9-5z"/><path d="M3 13l9 5 9-5"/>'),
    stripe: S('<path d="M5 3v18"/><path d="M11 3v18" opacity=".45"/><path d="M17 3v18"/>'),
    spiral: S('<path d="M12 12a3 3 0 1 1-3-3 5 5 0 1 1 5 5 7 7 0 1 1-7-7"/>'),
    drop: S('<path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/>'),
    dropHalf: S('<path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/><path d="M6.5 15h11" opacity=".5"/>'),
    dropLow: S('<path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/><path d="M6.6 17.5h10.8" opacity=".5"/>'),
    dropNone: S('<path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/><path d="M5 19 19 5"/>'),
    frizz: S('<path d="M4 18c1-2 2-2 3 0s2 2 3 0 2-2 3 0 2 2 3 0 2-2 3 0"/><path d="M6 12c1-3 2-1 3-4"/><path d="M12 11c1-4 2-2 3-5"/><path d="M17 12c1-3 1-2 2-4"/>'),
    timer: S('<circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M9 2h6"/>'),
    thermo: S('<path d="M14 14.8V5a2 2 0 0 0-4 0v9.8a4 4 0 1 0 4 0z"/><path d="M12 9v6"/>'),
    heartPulse: S('<path d="M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9z"/><path d="M6 12h3l1.5-2.5L13 14l1.5-2H18"/>'),
    check: S('<path d="M4 12.5 9 17.5 20 6.5"/>'),
    cross: S('<path d="M6 6l12 12"/><path d="M18 6 6 18"/>'),
    print: S('<path d="M7 9V3h10v6"/><rect x="4" y="9" width="16" height="7" rx="2"/><path d="M7 14h10v7H7z"/>'),
    copy: S('<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h9"/>'),
    life: S('<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><path d="m5.6 5.6 3.3 3.3M18.4 5.6l-3.3 3.3M5.6 18.4l3.3-3.3M18.4 18.4l-3.3-3.3"/>'),
    quote: S('<path d="M9 7H5v5h4c0 3-1 4-3 5"/><path d="M19 7h-4v5h4c0 3-1 4-3 5"/>'),
    star: S('<path d="m12 3 2.6 5.6 6 .8-4.4 4.2 1.1 6L12 16.8 6.7 19.6l1.1-6L3.4 9.4l6-.8z"/>')
  };

  /* ------------------------------------------------------------------ */
  /* Attachments — each carries the role it actually plays               */
  /* ------------------------------------------------------------------ */

  var ATTACH = {
    dryer_nozzle: {
      name: 'Concentrator Nozzle',
      media: 'concentrator',
      role: 'Moves the most air of any attachment. Its whole job is taking your hair from wet to damp, before any shaping starts.'
    },
    curling_barrels: {
      name: 'Auto-Wrap Barrels',
      media: 'barrel',
      role: 'Two barrels that wrap in opposite directions. Use the left one on the left side of your head and the right one on the right, so every curl turns away from your face.'
    },
    round_brush: {
      name: 'Round Volumising Brush',
      media: 'round-brush',
      role: 'Lifts at the root and rolls the ends. This is the volume tool — the shape is built where you place it, not along the whole length.'
    },
    smoothing_brush: {
      name: 'Smoothing Brush',
      media: 'smooth-brush',
      role: 'One controlled pass from root to ends. This is the polish tool: direction and steady tension do the work, not repetition.'
    }
  };

  var NOZZLE = ATTACH.dryer_nozzle.name;
  var BARRELS = ATTACH.curling_barrels.name;
  var ROUND = ATTACH.round_brush.name;
  var SMOOTH = ATTACH.smoothing_brush.name;

  /* ------------------------------------------------------------------ */
  /* Hair shades                                                         */
  /* Six families, opened one at a time. `maps` is the engine's colour    */
  /* value; the engine uses it for identity and colour notes only.        */
  /* ------------------------------------------------------------------ */

  var SHADES = [
    { id: 'blonde', label: 'Blonde', swatch: '#DCC9A8', tones: [
      { v: 'platinum',       l: 'Platinum',        hex: '#EDE4D4', maps: 'platinum_blonde' },
      { v: 'ash_blonde',     l: 'Ash blonde',      hex: '#CFC3AC', maps: 'blonde' },
      { v: 'beige_blonde',   l: 'Beige blonde',    hex: '#DCC9A8', maps: 'blonde' },
      { v: 'golden_blonde',  l: 'Golden blonde',   hex: '#D6B173', maps: 'blonde' },
      { v: 'honey',          l: 'Honey',           hex: '#C29553', maps: 'dark_blonde' },
      { v: 'strawberry',     l: 'Strawberry',      hex: '#C98F6A', maps: 'dark_blonde' }
    ] },
    { id: 'chestnut', label: 'Chestnut', swatch: '#A9754A', tones: [
      { v: 'bronde',         l: 'Bronde',          hex: '#937A5B', maps: 'dark_blonde' },
      { v: 'mushroom',       l: 'Mushroom',        hex: '#8A7C6E', maps: 'light_brown' },
      { v: 'light_chestnut', l: 'Light chestnut',  hex: '#A9855F', maps: 'light_brown' },
      { v: 'caramel',        l: 'Caramel',         hex: '#A9754A', maps: 'light_brown' },
      { v: 'chestnut',       l: 'Chestnut',        hex: '#8C6647', maps: 'brown' }
    ] },
    { id: 'brunette', label: 'Brunette', swatch: '#5A3B26', tones: [
      { v: 'light_brown',    l: 'Light brown',     hex: '#6F4E33', maps: 'brown' },
      { v: 'mocha',          l: 'Mocha',           hex: '#4A362A', maps: 'brown' },
      { v: 'medium_brown',   l: 'Medium brown',    hex: '#5A3B26', maps: 'brown' },
      { v: 'chocolate',      l: 'Chocolate',       hex: '#43291A', maps: 'dark_brown' },
      { v: 'espresso',       l: 'Espresso',        hex: '#2E1D13', maps: 'dark_brown' }
    ] },
    { id: 'red', label: 'Red & copper', swatch: '#B25A28', tones: [
      { v: 'strawberry_red', l: 'Strawberry red',  hex: '#C4744A', maps: 'red' },
      { v: 'copper',         l: 'Copper',          hex: '#B25A28', maps: 'copper' },
      { v: 'ginger',         l: 'Ginger',          hex: '#A8481E', maps: 'copper' },
      { v: 'auburn',         l: 'Auburn',          hex: '#7E3520', maps: 'red' },
      { v: 'burgundy',       l: 'Burgundy',        hex: '#5C1F22', maps: 'red' }
    ] },
    { id: 'black', label: 'Black', swatch: '#12100F', tones: [
      { v: 'soft_black',     l: 'Soft black',      hex: '#241C18', maps: 'black' },
      { v: 'jet_black',      l: 'Jet black',       hex: '#12100F', maps: 'black' },
      { v: 'blue_black',     l: 'Blue black',      hex: '#16181D', maps: 'black' }
    ] },
    { id: 'grey', label: 'Grey & silver', swatch: '#B9B6B1', tones: [
      { v: 'salt_pepper',    l: 'Salt and pepper', hex: '#6E6A66', maps: 'other' },
      { v: 'silver',         l: 'Silver',          hex: '#B9B6B1', maps: 'other' },
      { v: 'pearl_grey',     l: 'Pearl grey',      hex: '#D3D0CB', maps: 'other' },
      { v: 'white',          l: 'White',           hex: '#EAE8E4', maps: 'other' }
    ] }
  ];

  var SHADE_INDEX = {};
  SHADES.forEach(function (fam) {
    fam.tones.forEach(function (t) {
      SHADE_INDEX[t.v] = { family: fam.id, familyLabel: fam.label, label: t.l, hex: t.hex, maps: t.maps };
    });
  });

  /* ------------------------------------------------------------------ */
  /* Questions                                                           */
  /* ------------------------------------------------------------------ */

  /* Styling fundamentals that hold whatever the profile says. They sit after
     the spec library in the pick order, so a rule that actually matches the
     customer always wins; these only fill the remaining slots. Kept free of
     any device-feature claim (the HerLoom has no cool-shot step) and of any
     inference from hair colour. */
  var FALLBACK_MISTAKES = [
    { topic: 'cooling', when: {},
      text: 'Brushing a section out while it is still warm. Hair holds the shape it is in as it cools, so unpicking it warm undoes the pass you just made.' },
    { topic: 'tension', when: {},
      text: 'Letting the section go slack halfway down. Even tension from root to ends is what produces a smooth finish; a slack pass has to be repeated, and repeats are what cost you.' },
    { topic: 'overload', when: {},
      text: 'Loading too much hair into one section. Air cannot reach the middle, so the outside is finished while the inside is still wet.' },
    { topic: 'prep', when: {},
      text: 'Starting before the hair is fully detangled. Any knot you hit mid-pass forces you to stop, pull, and start that section again.' },
    { topic: 'direction', when: {},
      text: 'Changing the direction of the pass partway through a section. Pick the direction at the root and hold it all the way to the ends.' },
    { topic: 'dwell', when: {},
      text: 'Holding the attachment still in one spot. Keep it travelling — a stationary pass concentrates heat on a few centimetres of hair.' }
  ];

  var QUESTIONS = [
    {
      id: 'goal',
      title: 'What result do you want most?',
      help: 'This chooses the backbone of your routine. You can always come back and build a second plan.',
      cols: 2,
      options: [
        { v: 'soft_curls', l: 'Loose waves and soft curls', d: 'Relaxed movement you can run your fingers through, not tight spirals', i: 'curl' },
        { v: 'defined_curls', l: 'Tight, springy curls', d: 'Separate curls that bounce back when you pull one and let go', i: 'curlTight' },
        { v: 'bouncy_blowout', l: 'A full, bouncy blow-dry', d: 'Salon body through the whole length, with the ends turned under', i: 'volume' },
        { v: 'smooth_sleek', l: 'Straight and sleek', d: 'Flat and polished from root to tip, no bend left in it', i: 'sleek' },
        { v: 'root_volume', l: 'Just more lift at the roots', d: 'Height at the crown — the lengths stay exactly as they are', i: 'root' }
      ]
    },
    {
      id: 'chemical',
      title: 'Has your hair been coloured or chemically treated in the last 12 months?',
      help: 'Be honest here — this is one of only two answers that can lower your heat setting, and nothing later can raise it back up.',
      cols: 2,
      options: [
        { v: 'untreated', l: 'No, nothing at all', d: 'Still your natural colour, never been processed', i: 'leaf' },
        { v: 'dyed', l: 'Coloured all over', d: 'A box dye or a salon colour, roots included', i: 'palette' },
        { v: 'highlighted', l: 'Highlights or balayage', d: 'Only some strands lightened, not the whole head', i: 'stripe' },
        { v: 'bleached', l: 'Bleached or lightened a lot', d: 'Lifted several shades — platinum, or blonde from dark hair', i: 'shield' },
        { v: 'smoothing_treatment', l: 'Keratin or a smoothing treatment', d: 'A salon treatment to make it straighter or less frizzy', i: 'flask' },
        { v: 'permed', l: 'A perm or a curling treatment', d: 'A salon treatment that added curl or wave', i: 'spiral' },
        { v: 'multiple_treatments', l: 'More than one of these', d: 'For example coloured and also keratin-treated', i: 'layers' }
      ]
    },
    {
      id: 'condition',
      title: 'How would you describe the current condition of your hair?',
      help: 'Go by how it behaves, not by how it looks in good light.',
      cols: 2,
      options: [
        { v: 'healthy', l: 'Healthy, feels strong', d: 'Stretches and springs back', i: 'heartPulse' },
        { v: 'slightly_dry', l: 'Slightly dry', d: 'A little rough at the ends', i: 'dropHalf' },
        { v: 'dry_fragile', l: 'Dry or fragile', d: 'Snaps if you detangle carelessly', i: 'dropLow' },
        { v: 'very_fragile', l: 'Very fragile, breaks easily', d: 'You find broken pieces regularly', i: 'shield' }
      ]
    },
    {
      id: 'pattern',
      title: 'What is your natural hair pattern?',
      help: 'Air-dried, with no product and no brushing.',
      cols: 2,
      options: [
        { v: 'straight', l: 'Straight', d: 'Falls flat, little to no bend', i: 'straight' },
        { v: 'wavy', l: 'Wavy', d: 'S-shaped bends, loosens as it dries', i: 'wave' },
        { v: 'curly', l: 'Curly', d: 'Defined spirals', i: 'curl' },
        { v: 'coily', l: 'Coily', d: 'Tight coils or zig-zag pattern', i: 'coil' }
      ]
    },
    {
      id: 'thickness',
      title: 'How thick is an individual strand of your hair?',
      help: 'Pull out one strand and roll it between your fingers. Barely there? Fine. Wiry and easy to feel? Coarse.',
      options: [
        { v: 'fine', l: 'Fine', d: 'Hard to feel between your fingers', i: 'strandFine' },
        { v: 'medium', l: 'Medium', d: 'You can feel it, but it is not wiry', i: 'strandMedium' },
        { v: 'coarse', l: 'Coarse', d: 'Wiry, easy to feel, holds its own shape', i: 'strandThick' }
      ]
    },
    {
      id: 'density',
      title: 'What is the density of your hair?',
      help: 'Density is how many hairs you have on your head — not how thick each single hair is.',
      options: [
        { v: 'low_density', l: 'Low', c: 'Low density', d: 'Your scalp shows through easily, even without parting it', i: 'densityLow' },
        { v: 'medium_density', l: 'Medium', c: 'Medium density', d: 'Your scalp shows a little at the parting, not elsewhere', i: 'densityMed' },
        { v: 'high_density', l: 'High', c: 'High density', d: 'Very full — your scalp barely shows at all', i: 'densityHigh' },
        { v: '', l: "I'm not sure", d: 'Answer one quick question instead', i: 'help', follow: 'ponytail' }
      ],
      follows: {
        ponytail: {
          title: 'Let us work it out from your ponytail',
          help: 'Tie your hair back, then look at how thick the ponytail is where the band sits.',
          options: [
            { v: 'low_density', l: 'About as thick as one finger', d: 'Or thinner', i: 'densityLow' },
            { v: 'medium_density', l: 'About two or three fingers thick', d: 'The most common answer', i: 'densityMed' },
            { v: 'high_density', l: 'Thicker than three fingers', d: 'A wide, heavy ponytail', i: 'densityHigh' }
          ]
        }
      }
    },
    {
      id: 'length',
      title: 'How long is your hair?',
      options: [
        { v: 'short', l: 'Short', d: 'Above the shoulders', i: 'lenShort' },
        { v: 'shoulder', l: 'Shoulder length', d: 'Collarbone to shoulder blade', i: 'lenMid' },
        { v: 'long', l: 'Long', d: 'Around mid-back', i: 'lenLong' },
        { v: 'very_long', l: 'Very long', d: 'Past the mid-back', i: 'lenVeryLong' }
      ]
    },
    {
      id: 'shade',
      type: 'shade',
      title: 'What shade is your hair right now?',
      help: 'Pick the family first, then the closest tone. Your colour personalises your profile — it never changes your heat setting.'
    },
    {
      id: 'challenge',
      title: 'What frustrates you most when styling your hair?',
      help: 'Pick the one that gets in your way most often. It becomes the priority your plan is built around.',
      cols: 2,
      options: [
        { v: 'curls_drop', l: 'My curls fall quickly', d: 'The shape drops within the hour', i: 'drop' },
        { v: 'frizz', l: 'Frizz and flyaways', d: 'A rough surface and a halo', i: 'frizz' },
        { v: 'low_volume', l: 'Not enough volume', d: 'Flat roots, no lift', i: 'volume' },
        { v: 'takes_too_long', l: 'Styling takes too long', d: 'I run out of patience before I finish', i: 'timer' },
        { v: 'hard_to_smooth', l: 'My hair is hard to smooth', d: 'It never quite goes flat', i: 'sleek' },
        { v: 'heat_concern', l: 'I worry about heat damage', d: 'I would rather stay cautious', i: 'thermo' }
      ]
    },
    {
      id: 'moisture',
      title: 'How wet is your hair when you usually start styling?',
      help: 'This decides how much of your routine is drying and how much is actually shaping.',
      cols: 2,
      options: [
        { v: 'soaking_wet', l: 'Soaking wet', d: 'Straight out of the shower', i: 'drop' },
        { v: 'towel_dried', l: 'Towel-dried, damp', d: 'Blotted but still wet to the touch', i: 'dropHalf' },
        { v: 'mostly_dry', l: 'Mostly dry', d: 'Only a little damp left', i: 'dropLow' },
        { v: 'fully_dry', l: 'Fully dry', d: 'Completely dry before I start', i: 'dropNone' }
      ]
    },
    {
      id: 'time',
      title: 'How much time do you usually have?',
      help: 'This never changes your settings — only how much of your hair the plan asks you to finish in detail.',
      options: [
        { v: 'under_10', l: 'Under 10 minutes', d: 'Visible sections first', i: 'bolt' },
        { v: '10_20', l: '10 to 20 minutes', d: 'Every visible section', i: 'clock' },
        { v: 'over_20', l: 'More than 20 minutes', d: 'Every layer, properly', i: 'timer' }
      ]
    }
  ];

  /* Flat lookup of every answer label, for chips and trigger tags. */
  var LABELS = {};
  QUESTIONS.forEach(function (q) {
    (q.options || []).forEach(function (o) { if (o.v) LABELS[q.id + ':' + o.v] = o.c || o.l; });
  });
  Object.keys(SHADE_INDEX).forEach(function (v) {
    LABELS['color:' + SHADE_INDEX[v].maps] = SHADE_INDEX[v].label;
  });

  /* ------------------------------------------------------------------ */
  /* Routine fragments                                                   */
  /* tier: core = always · plus = 10 min and up · full = 20 min and up   */
  /* ------------------------------------------------------------------ */

  var MOISTURE_STEP = {
    soaking_wet: 'Pre-dry with the ' + NOZZLE + ' until your hair is damp rather than wet. At your starting moisture this step is not optional.',
    towel_dried: 'Give your hair a short pre-dry with the ' + NOZZLE + ' so it is evenly damp, not wet.',
    mostly_dry: 'A pre-dry is optional here. Use the ' + NOZZLE + ' only on any section that still feels wet.',
    fully_dry: 'Mist your hair lightly damp before shaping. Completely dry hair is less cooperative with airflow.',
    fully_dry_smooth: 'No pre-dry needed at your starting moisture. Go straight into shaping.'
  };

  var GOAL_STEPS = {
    soft_curls: [
      { t: 'Fit the ' + BARRELS + '. Take one section, present the ends to the airflow and let the barrel draw the hair in.', tier: 'core' },
      { t: 'Switch the device off before you release each curl. Releasing under airflow unwinds the shape you just made.', tier: 'core' },
      { t: 'Catch the curl in your hand and hold it, or pin it against your head, while it cools.', tier: 'core' },
      { t: 'Work through your zones with the under-layers first, swapping barrels as you change side.', tier: 'plus' },
      { t: 'Do the face-framing pieces last, curling them away from your face.', tier: 'full' }
    ],
    defined_curls: [
      { t: 'Fit the ' + BARRELS + '. Keep every section the same size — definition comes from repeatability, not from heat.', tier: 'core' },
      { t: 'Present the ends first and let the barrel wrap the section on its own.', tier: 'core' },
      { t: 'Switch the device off before releasing, and let each curl drop into your hand.', tier: 'core' },
      { t: 'Pin each curl against your head while it cools so it keeps its diameter.', tier: 'plus' },
      { t: 'Leave every curl alone until the whole head is cool, then separate only as much as you want.', tier: 'core' },
      { t: 'Go back over any curl that ended up wider than its neighbours.', tier: 'full' }
    ],
    bouncy_blowout: [
      { t: 'Fit the ' + ROUND + '. Place it under the section at the root and lift to about 90 degrees.', tier: 'core' },
      { t: 'Hold at the root for a few seconds, then travel down the length in one movement.', tier: 'core' },
      { t: 'Roll the ends under, or out, and pause there before releasing.', tier: 'core' },
      { t: 'Work from the bottom layers upwards, finishing with the crown.', tier: 'plus' },
      { t: 'Clip the crown sections up while they finish cooling, to hold the lift.', tier: 'full' },
      { t: 'Break the shape up with your fingers at the very end.', tier: 'core' }
    ],
    smooth_sleek: [
      { t: 'Fit the ' + SMOOTH + '. Run it from root to ends in one continuous, controlled pass.', tier: 'core' },
      { t: 'Keep the airflow pointing down the hair, in the same direction, for the whole pass.', tier: 'core' },
      { t: 'Repeat a pass only if the section is genuinely not smooth yet.', tier: 'core' },
      { t: 'Work through every panel, ending with the top layer.', tier: 'plus' },
      { t: 'Finish the face-framing sections with a slight bend at the ends.', tier: 'full' }
    ],
    root_volume: [
      { t: 'Fit the ' + ROUND + '. Start at the crown — that is where lift actually shows.', tier: 'core' },
      { t: 'Lift each section to about 90 degrees from your scalp before you apply any airflow.', tier: 'core' },
      { t: 'Work in the opposite direction to the way your hair naturally falls.', tier: 'core' },
      { t: 'Let the root cool while the section is still lifted. Dropping it early undoes the lift.', tier: 'core' },
      { t: 'Keep product and repeated passes off the root area.', tier: 'plus' },
      { t: 'Leave the lengths mostly alone. The silhouette is built at the top.', tier: 'full' }
    ]
  };

  var FINISH_STEP = {
    curls_drop: 'Wait until everything is completely cool before you separate anything, and use your fingers rather than a brush.',
    frizz: 'Handle your hair as little as possible now. Most of the frizz you notice appears after the styling, not during it.',
    low_volume: 'Tip your head forward and shake the roots gently instead of brushing the volume back out.',
    takes_too_long: 'Stop at the sections that are actually visible. The under-layer at the nape does not need finishing.',
    hard_to_smooth: 'Check the top layer in the mirror and re-pass only the sections that still look uneven.',
    heat_concern: 'If the result is already there, stop. Extra passes are the part of the routine that costs you the most.'
  };

  var TIME_META = {
    under_10: { title: 'Your express routine', keep: ['core'],
      note: 'Under ten minutes means finishing the sections that are seen, properly — not finishing everything, badly.' },
    '10_20': { title: 'Your standard routine', keep: ['core', 'plus'],
      note: 'Enough time to work through every visible section with an even result. Treat the estimate as a guide, not a promise.' },
    over_20: { title: 'Your full routine', keep: ['core', 'plus', 'full'],
      note: 'With this much time you can work every layer and give each section a proper cool-down.' }
  };

  /* ------------------------------------------------------------------ */
  /* Rule interpreter — reads the generated library, holds no copy        */
  /* ------------------------------------------------------------------ */

  function matches(profile, when) {
    return Object.keys(when).every(function (key) {
      return when[key].indexOf(profile[key]) >= 0;
    });
  }

  function matchesAny(profile, list) {
    return list.some(function (when) { return matches(profile, when); });
  }

  var HEAT_RANK = { LOW: 1, MEDIUM: 2, HIGH: 3 };

  function capReason(when) {
    if (when.chemical && when.condition) {
      return 'Capped because lightened hair that already feels dry or fragile is the most exposed combination in your profile.';
    }
    if (when.condition && when.thickness) {
      return 'Capped by dry or fragile hair on fine strands. Neither your goal nor your pattern can raise it.';
    }
    if (when.chemical) {
      return 'Capped by your chemical history. Strand thickness and hair pattern cannot raise it back up.';
    }
    return 'Capped by the condition you reported. This is a ceiling, not a starting point to build on.';
  }

  function resolveHeat(p) {
    var cfg = ENGINE.logic.heat;
    var cap = null, reason = null;

    cfg.hard_caps.forEach(function (rule) {
      if (!cap && matches(p, rule.when)) { cap = rule.max; reason = capReason(rule.when); }
    });

    var score = 0;
    cfg.score_rules.forEach(function (rule) {
      if (matches(p, rule.when)) score += rule.delta;
    });

    var value = cfg.base;
    cfg.mapping.forEach(function (band) {
      var okMin = band.min === undefined || score > band.min;
      var okMax = band.max === undefined || score <= band.max;
      if (okMin && okMax) value = band.value;
    });

    if (cap && HEAT_RANK[value] > HEAT_RANK[cap]) value = cap;

    if (!reason) {
      reason = p.challenge === 'heat_concern'
        ? 'You asked to stay cautious, so this is the lowest setting that should still get the result. Move up only if it genuinely will not hold.'
        : 'A starting point, not a prescription. Move up only if the result genuinely will not hold.';
    }
    return { value: value, reason: reason, capped: !!cap };
  }

  function resolveSection(p) {
    var cfg = ENGINE.logic.section_size;
    var score = 0;
    cfg.score_rules.forEach(function (rule) {
      if (matches(p, rule.when)) score += rule.delta;
    });
    if (score >= cfg.small_if_score_gte) return 'Small';

    var large = cfg.large_only_if;
    var canBeLarge =
      large.density.indexOf(p.density) >= 0 &&
      large.thickness_not.indexOf(p.thickness) < 0 &&
      large.goal_not.indexOf(p.goal) < 0 &&
      large.challenge_not.indexOf(p.challenge) < 0 &&
      large.length_not.indexOf(p.length) < 0;

    if (canBeLarge && ['smooth_sleek', 'bouncy_blowout'].indexOf(p.goal) >= 0) return 'Large';
    return 'Medium';
  }

  var ZONE_ORDER = ['3–4', '4–6', '6–8'];

  function resolveZones(p) {
    var cfg = ENGINE.logic.zones;
    var value = cfg.fallback;
    for (var i = 0; i < cfg.rules.length; i++) {
      if (matchesAny(p, cfg.rules[i].when_any)) { value = cfg.rules[i].value; break; }
    }
    cfg.overrides.forEach(function (o) {
      if (!matches(p, o.when)) return;
      if (o.value) value = o.value;
      if (o.min && ZONE_ORDER.indexOf(value) < ZONE_ORDER.indexOf(o.min)) value = o.min;
    });
    return value;
  }

  function pickDistinct(library, p, max) {
    var out = [], topics = {};
    for (var i = 0; i < library.length && out.length < max; i++) {
      var item = library[i];
      if (topics[item.topic]) continue;
      if (!matches(p, item.when)) continue;
      topics[item.topic] = true;
      out.push(item);
    }
    return out;
  }

  function triggerChips(p, when) {
    return Object.keys(when).map(function (key) {
      return LABELS[key + ':' + p[key]] || null;
    }).filter(Boolean);
  }

  /* ------------------------------------------------------------------ */
  /* Plan                                                                */
  /* ------------------------------------------------------------------ */

  function buildPlan(answers) {
    var shade = SHADE_INDEX[answers.shade] || null;

    /* The engine profile. `color` is the mapped spec value, never the tone. */
    var p = {
      goal: answers.goal,
      condition: answers.condition,
      pattern: answers.pattern,
      thickness: answers.thickness,
      density: answers.density,
      length: answers.length,
      color: shade ? shade.maps : 'other',
      challenge: answers.challenge,
      chemical: answers.chemical,
      moisture: answers.moisture,
      time: answers.time
    };

    var heat = resolveHeat(p);
    var sectionSize = resolveSection(p);
    var zones = resolveZones(p);

    var order = (ENGINE.logic.attachment_order[p.goal] || []).map(function (key) {
      return ATTACH[key === 'dryer_if_needed' ? 'dryer_nozzle' : key];
    }).filter(Boolean);

    var libs = ENGINE.libraries;

    var chips = [
      LABELS['thickness:' + p.thickness],
      LABELS['density:' + p.density],
      shade ? shade.label : null,
      p.chemical !== 'untreated' ? LABELS['chemical:' + p.chemical] : null,
      LABELS['challenge:' + p.challenge]
    ].filter(Boolean);

    return {
      answers: answers,
      profile: p,
      name: LABELS['goal:' + p.goal],
      shade: shade,
      chips: chips,
      heat: heat,
      sectionSize: sectionSize,
      zones: zones,
      attachments: order,
      expert: pickDistinct(libs.expert_insights, p, 2),
      insights: pickDistinct(libs.personalized_insights, p, 5),
      mistakes: pickDistinct(libs.mistakes.concat(FALLBACK_MISTAKES), p, 5),
      care: pickDistinct(libs.care_notes, p, 2),
      routine: buildRoutine(p, sectionSize, zones),
      code: styleCode(p)
    };
  }

  /* Teaser mode. The locked advice is reduced to how many items there are
     before anything is handed to the renderer, so the page never carries the
     text and no amount of unblurring in devtools reveals it. What she does get
     is real: one expert note and one insight actually matched to her answers,
     which is what proves the quiz is not decoration. */
  function buildTeaserPlan(answers) {
    var full = buildPlan(answers);
    return {
      answers: full.answers,
      profile: full.profile,
      name: full.name,
      shade: full.shade,
      chips: full.chips,
      code: full.code,
      freeExpert: full.expert[0] || null,
      freeInsight: full.insights[0] || null,
      counts: {
        settings: 3,
        insights: Math.max(full.insights.length - 1, 0),
        attachments: full.attachments.length,
        routine: (full.routine.steps || []).length,
        mistakes: full.mistakes.length,
        care: full.care.length
      }
    };
  }

  function buildRoutine(p, sectionSize, zones) {
    var meta = TIME_META[p.time] || TIME_META['10_20'];
    var steps = [];

    steps.push({ t: 'Detangle gently, working up from the ends.', tier: 'core' });
    steps.push({ t: 'Blot the excess water out with a towel rather than rubbing.', tier: 'core' });
    steps.push({ t: 'If you use a heat protectant, apply it now and follow its own instructions.', tier: 'plus' });

    var moistureKey = p.moisture;
    if (moistureKey === 'fully_dry' && ['smooth_sleek', 'root_volume'].indexOf(p.goal) >= 0) {
      moistureKey = 'fully_dry_smooth';
    }
    steps.push({ t: MOISTURE_STEP[moistureKey], tier: 'core' });

    steps.push({
      t: 'Split your hair into ' + zones + ' zones and clip them out of the way, then work in ' +
         sectionSize.toLowerCase() + ' sections.',
      tier: 'core'
    });

    (GOAL_STEPS[p.goal] || []).forEach(function (s) { steps.push(s); });

    steps.push({ t: 'Let every section cool completely in the shape you gave it before you touch it again.', tier: 'core' });

    if (FINISH_STEP[p.challenge]) {
      steps.push({ t: FINISH_STEP[p.challenge], tier: 'core' });
    }

    return {
      title: meta.title,
      note: meta.note,
      steps: steps.filter(function (s) { return meta.keep.indexOf(s.tier) >= 0; })
    };
  }

  function styleCode(p) {
    var initials = function (v) {
      return String(v).split('_').map(function (w) { return w.charAt(0).toUpperCase(); }).join('');
    };
    return ['HL', initials(p.goal),
            p.thickness.charAt(0).toUpperCase() + p.density.charAt(0).toUpperCase(),
            initials(p.chemical), initials(p.challenge)].join('-');
  }

  /* ------------------------------------------------------------------ */
  /* Rendering helpers                                                   */
  /* ------------------------------------------------------------------ */

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function repeat(count, make) {
    var out = '';
    for (var i = 0; i < count; i++) out += make(i);
    return out;
  }

  function block(num, title, inner) {
    return '<section class="hsid__block">' +
      '<div class="hsid__block-head"><span class="hsid__block-num">' + num + '</span>' +
      '<h3 class="hsid__block-title">' + esc(title) + '</h3></div>' + inner + '</section>';
  }

  /* ------------------------------------------------------------------ */
  /* Controller                                                          */
  /* ------------------------------------------------------------------ */

  function init(root) {
    if (!root || root.dataset.hsidReady === 'true') return;
    if (!ENGINE || !ENGINE.logic || !ENGINE.libraries) return;
    root.dataset.hsidReady = 'true';

    var cfgEl = root.querySelector('[data-hsid-config]');
    var CFG = {};
    try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }

    var screens = {};
    root.querySelectorAll('[data-screen]').forEach(function (el) { screens[el.dataset.screen] = el; });

    /* ---- Analytics ------------------------------------------------------
       Events go straight to PostHog's capture endpoint - no posthog-js, so
       nothing extra is downloaded on a page that already carries Clarity,
       the Meta pixel and Loox.

       Two details that matter:
       - Content-Type is text/plain, not application/json. sendBeacon cannot
         perform a CORS preflight, so a JSON content type fails silently on
         the unload path. PostHog accepts text/plain bodies for this reason.
       - distinct_id is sent both at the top level and inside properties,
         because ingestion accepts either shape.

       With no key configured, track() does nothing at all. */

    var PH_KEY = CFG.phKey || '';
    var PH_HOST = (CFG.phHost || 'https://us.i.posthog.com').replace(/\/+$/, '');
    var phQueue = [];

    function randomId() {
      try {
        var a = new Uint8Array(9);
        (window.crypto || window.msCrypto).getRandomValues(a);
        return Array.prototype.map.call(a, function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
      } catch (e) {
        return String(Date.now()) + Math.random().toString(16).slice(2, 10);
      }
    }

    /* A first-party random id. Never a name, never an email - it only lets
       repeat visits and the steps of one run line up. */
    function storedId(store, key) {
      try {
        var v = window[store].getItem(key);
        if (!v) { v = randomId(); window[store].setItem(key, v); }
        return v;
      } catch (e) {
        return randomId();
      }
    }

    var phVisitor = storedId('localStorage', 'hsid_visitor');
    var phSession = storedId('sessionStorage', 'hsid_session');

    function track(event, props) {
      if (!PH_KEY) return;
      var p = { distinct_id: phVisitor, session: phSession, mode: CFG.mode || 'full' };
      if (props) Object.keys(props).forEach(function (k) { p[k] = props[k]; });
      phQueue.push({
        event: 'hsid_' + event,
        distinct_id: phVisitor,
        properties: p,
        timestamp: new Date().toISOString()
      });
      if (phQueue.length >= 20) flushTrack(false);
    }

    function flushTrack(unloading) {
      if (!PH_KEY || !phQueue.length) return;
      var body = JSON.stringify({ api_key: PH_KEY, batch: phQueue });
      phQueue = [];
      var url = PH_HOST + '/batch/';
      try {
        if (unloading && navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
          return;
        }
        /* Default CORS mode on purpose: PostHog allows browser posts, and an
           opaque no-cors response would hide a wrong key or region behind a
           silent success. text/plain keeps it a simple request, no preflight. */
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: body,
          keepalive: true
        }).catch(function () {});
      } catch (e) { /* analytics must never break the quiz */ }
    }

    // Anything still queued when the tab goes away.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushTrack(true);
    });
    window.addEventListener('pagehide', function () { flushTrack(true); });


    var mountQ = root.querySelector('[data-question-mount]');
    var mountR = root.querySelector('[data-result-mount]');
    var fill = root.querySelector('[data-fill]');
    var count = root.querySelector('[data-count]');
    var backBtn = root.querySelector('[data-back]');
    var library = root.querySelector('[data-hsid-library]');
    var toast = root.querySelector('[data-toast]');
    var welcome = root.querySelector('[data-welcome]');

    var answers = {};
    var index = 0;
    var timers = [];
    var shadeFamilyOpen = null;
    var ownerName = '';

    function ownerEyebrow() {
      return ownerName ? ownerName + '’s HerLoom Style ID' : 'Your HerLoom Style ID';
    }

    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }

    function libNode(sel) { return library ? library.querySelector(sel) : null; }

    /* The portraits are illustrative, so which note gets which face carries no
       meaning — the only rule that matters is that two notes shown one after
       the other never wear the same one. Walking the pool by one per note
       guarantees that; the profile-derived start just stops every customer
       seeing the same first face. */
    function expertFaces() {
      if (!library) return [];
      var nodes = library.querySelectorAll('[data-expert-photo] img');
      if (!nodes.length) nodes = library.querySelectorAll('[data-expert-image] img');
      return Array.prototype.slice.call(nodes);
    }

    function faceOffset(seed) {
      var h = 0;
      for (var i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 9973;
      return h;
    }

    function answerImage(qid, value) {
      var node = libNode('[data-answer-image][data-key="' + qid + ':' + value + '"] img');
      return node ? node.outerHTML : '';
    }

    /* ---- Screens ---- */

    function show(name) {
      Object.keys(screens).forEach(function (k) {
        screens[k].classList.toggle('is-active', k === name);
      });
      root.classList.toggle('is-door', name === 'door');
      if (welcome && name !== 'door') welcome.hidden = true;
      if (name !== 'door') {
        var top = root.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    function flash(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-on');
      later(function () { toast.classList.remove('is-on'); }, 2400);
    }

    /* ---- The salon entrance ---- */

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function openDoors(then) {
      if (root.classList.contains('is-opening')) return;
      clearTimers();
      if (reduced) { root.classList.remove('is-door'); then(); return; }
      root.classList.add('is-opening');
      later(function () { root.classList.add('is-white'); }, 1000);
      later(function () {
        root.classList.remove('is-opening');
        then();
        later(function () { root.classList.remove('is-white'); }, 60);
      }, 1620);
    }

    /* ---- Quiz ---- */

    /* An option may hand off to a follow-up instead of answering: the customer
       who cannot judge their own density gets the ponytail test rather than a
       guess. The follow-up writes the same answer key, so the engine never
       knows the difference. */
    var subOpen = null;

    function renderQuestion(subKey) {
      subOpen = subKey || null;
      var q = QUESTIONS[index];
      var view = subOpen ? q.follows[subOpen] : q;
      var pct = (index / QUESTIONS.length) * 100;
      if (fill) fill.style.width = pct + '%';
      if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(QUESTIONS.length).padStart(2, '0');
      if (backBtn) backBtn.disabled = index === 0 && !subOpen;

      if (q.type === 'shade') { renderShadeQuestion(q); return; }

      var withPhotos = view.options.some(function (o) { return !!answerImage(q.id, o.v); });

      mountQ.innerHTML =
        '<div class="hsid__q">' +
          '<h2 class="hsid__q-title" id="' + root.id + '-q">' + esc(view.title) + '</h2>' +
          (view.help ? '<p class="hsid__q-help">' + esc(view.help) + '</p>' : '') +
          '<div class="hsid__options' + (withPhotos ? ' hsid__options--photo' : '') + '" role="group" ' +
            'aria-labelledby="' + root.id + '-q"' + (view.cols ? ' data-cols="' + view.cols + '"' : '') + '>' +
            view.options.map(function (o) {
              var picked = !!o.v && answers[q.id] === o.v;
              var photo = answerImage(q.id, o.v);
              var visual = photo
                ? '<span class="hsid__opt-photo">' + photo + '</span>'
                : '<span class="hsid__opt-icon">' + (ICONS[o.i] || ICONS.star) + '</span>';
              return '<button type="button" class="hsid__opt" data-value="' + esc(o.v) + '"' +
                (o.follow ? ' data-follow="' + esc(o.follow) + '"' : '') +
                ' aria-pressed="' + picked + '">' +
                visual +
                '<span class="hsid__opt-text"><span class="hsid__opt-label">' + esc(o.l) + '</span>' +
                (o.d ? '<span class="hsid__opt-desc">' + esc(o.d) + '</span>' : '') + '</span>' +
                '<span class="hsid__opt-tick">' + ICONS.check + '</span>' +
              '</button>';
            }).join('') +
          '</div>' +
        '</div>';

      mountQ.querySelectorAll('.hsid__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.follow) {
            track('followup', { question: QUESTIONS[index].id, followup: btn.dataset.follow });
            renderQuestion(btn.dataset.follow);
            return;
          }
          answers[QUESTIONS[index].id] = btn.dataset.value;
          track('answer', {
            question: QUESTIONS[index].id,
            answer: btn.dataset.value,
            step: index + 1,
            progress_pct: Math.round(((index + 1) / QUESTIONS.length) * 100)
          });
          mountQ.querySelectorAll('.hsid__opt').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          later(next, 190);
        });
      });
    }

    /* The shade picker: families first, tones underneath. */
    function renderShadeQuestion(q) {
      var current = SHADE_INDEX[answers.shade];
      var openFamily = shadeFamilyOpen || (current && current.family) || null;

      var families = SHADES.map(function (fam) {
        var on = fam.id === openFamily;
        return '<button type="button" class="hsid__fam" data-family="' + fam.id + '" aria-pressed="' + on + '">' +
          '<span class="hsid__fam-dot" style="background:' + fam.swatch + '"></span>' +
          '<span>' + esc(fam.label) + '</span>' +
        '</button>';
      }).join('');

      var tones = '';
      if (openFamily) {
        var fam = SHADES.filter(function (f) { return f.id === openFamily; })[0];
        tones = '<div class="hsid__tones" role="group" aria-label="' + esc(fam.label) + ' tones">' +
          fam.tones.map(function (t) {
            var on = answers.shade === t.v;
            return '<button type="button" class="hsid__tone" data-tone="' + t.v + '" aria-pressed="' + on + '">' +
              '<span class="hsid__tone-dot" style="background:' + t.hex + '"></span>' +
              '<span class="hsid__tone-label">' + esc(t.l) + '</span>' +
            '</button>';
          }).join('') + '</div>';
      }

      mountQ.innerHTML =
        '<div class="hsid__q">' +
          '<h2 class="hsid__q-title" id="' + root.id + '-q">' + esc(q.title) + '</h2>' +
          '<p class="hsid__q-help">' + esc(q.help) + '</p>' +
          '<div class="hsid__fams" role="group" aria-labelledby="' + root.id + '-q">' + families + '</div>' +
          tones +
        '</div>';

      mountQ.querySelectorAll('.hsid__fam').forEach(function (btn) {
        btn.addEventListener('click', function () {
          shadeFamilyOpen = btn.dataset.family;
          renderShadeQuestion(q);
        });
      });
      mountQ.querySelectorAll('.hsid__tone').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track('answer', {
            question: 'shade',
            answer: btn.dataset.tone,
            step: index + 1,
            progress_pct: Math.round(((index + 1) / QUESTIONS.length) * 100)
          });
        });
        btn.addEventListener('click', function () {
          answers.shade = btn.dataset.tone;
          mountQ.querySelectorAll('.hsid__tone').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          later(next, 230);
        });
      });
    }

    function next() {
      if (index < QUESTIONS.length - 1) {
        index += 1;
        renderQuestion();
      } else {
        if (fill) fill.style.width = '100%';
        save();
        askName();
      }
    }

    function back() {
      if (subOpen) { renderQuestion(); return; }
      if (index === 0) return;
      index -= 1;
      renderQuestion();
    }

    /* ---- First name (optional, asked last) ---- */

    function askName() {
      if (!screens.name) { runLoading(); return; }
      show('name');
      var input = screens.name.querySelector('[data-name-input]');
      if (input) {
        input.value = ownerName || '';
        later(function () { try { input.focus(); } catch (e) {} }, 320);
      }
    }

    function bindNameScreen() {
      if (!screens.name) return;
      var form = screens.name.querySelector('[data-name-form]');
      var input = screens.name.querySelector('[data-name-input]');
      var skip = screens.name.querySelector('[data-name-skip]');
      var backTo = screens.name.querySelector('[data-name-back]');

      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        ownerName = input ? input.value.trim().slice(0, 24) : '';
        track('name', { given: !!ownerName });
        save();
        runLoading();
      });

      // Skipping is a real choice, so it clears any name kept from last time.
      if (skip) skip.addEventListener('click', function () {
        track('name', { given: false, skipped: true });
        ownerName = '';
        if (input) input.value = '';
        save();
        runLoading();
      });

      if (backTo) backTo.addEventListener('click', function () {
        show('quiz');
        renderQuestion();
      });
    }

    /* ---- Loading ---- */

    function runLoading() {
      /* The engine is deterministic, so the eleven answers are enough - heat,
         slice size and zones can always be recomputed from them later. */
      var done = { progress_pct: 100 };
      Object.keys(answers).forEach(function (k) { done[k] = answers[k]; });
      try { done.code = buildPlan(answers).code; } catch (e) {}
      track('complete', done);
      flushTrack(false);

      show('loading');
      var steps = screens.loading.querySelectorAll('.hsid__step');
      steps.forEach(function (s) { s.classList.remove('is-on', 'is-done'); });
      steps.forEach(function (s, i) {
        later(function () { s.classList.add('is-on'); }, 180 + i * 620);
        later(function () { s.classList.add('is-done'); }, 620 + i * 620);
      });
      later(function () {
        renderPlanScreen();
        show('result');
        requestAnimationFrame(initSpinners);
      }, 400 + steps.length * 620);
    }

    /* ---- Result ---- */

    function attachmentCard(att, i) {
      var src = libNode('[data-attachment][data-key="' + att.media + '"]');
      var still = src && src.querySelector('[data-still]');
      var video = src && src.querySelector('[data-video]');
      var media = '';
      if (still && still.innerHTML.trim()) {
        var hasVideo = video && video.innerHTML.trim();
        media = '<span class="hsid__att-media' + (hasVideo ? ' has-video' : '') + '" data-att-media>' +
          still.innerHTML +
          (hasVideo ? '<span class="hsid__att-video">' + video.innerHTML + '</span>' : '') +
          '</span>';
      }
      return '<li class="hsid__att">' + media +
        '<span class="hsid__att-step">Step ' + (i + 1) + '</span>' +
        '<span class="hsid__att-name">' + esc(att.name) + '</span>' +
        '<span class="hsid__att-role">' + esc(att.role) + '</span>' +
      '</li>';
    }

    var TEASER = (CFG.mode || 'full') === 'teaser';

    function renderPlanScreen() {
      if (TEASER) renderTeaser(buildTeaserPlan(answers));
      else renderResult(buildPlan(answers));
    }

    /* Blurred filler. Widths vary so a stack of these reads as paragraphs
       rather than as a loading state. */
    function ghostLines(widths) {
      return '<span class="hsid__ghost" aria-hidden="true">' + widths.map(function (w) {
        return '<span class="hsid__ghost-line" style="width:' + w + '%"></span>';
      }).join('') + '</span>';
    }

    function lockedBlock(num, title, count, noun, inner) {
      return '<section class="hsid__block hsid__block--locked">' +
        '<div class="hsid__block-head">' +
          '<span class="hsid__block-num">' + num + '</span>' +
          '<h3 class="hsid__block-title">' + esc(title) + '</h3>' +
          '<span class="hsid__locked-count">' + count + ' ' + esc(noun) + '</span>' +
        '</div>' +
        '<div class="hsid__locked-body">' + inner + '</div>' +
      '</section>';
    }

    function renderTeaser(plan) {
      var faces = expertFaces();
      var portrait = faces.length ? faces[faceOffset(plan.code || '') % faces.length] : null;
      var c = plan.counts;
      var html = '';

      html += '<div class="hsid__card">' +
        '<p class="hsid__eyebrow">Your HerLoom Style ID</p>' +
        (ownerName ? '<p class="hsid__owner">' + esc(ownerName) + '</p>' : '') +
        '<h2 class="hsid__card-title">' + esc(plan.name) + '</h2>' +
        '<div class="hsid__tags">' + plan.chips.map(function (t) {
          return '<span class="hsid__tag">' + esc(t) + '</span>';
        }).join('') + '</div>' +
        (plan.shade
          ? '<p class="hsid__shade"><span class="hsid__shade-dot" style="background:' + plan.shade.hex + '"></span>' +
            esc(plan.shade.label) + '</p>'
          : '') +
        '<p class="hsid__code">Profile ' + esc(plan.code) + '</p>' +
      '</div>';

      if (plan.freeExpert) {
        html += block('01', 'HerLoom Expert Notes',
          '<div class="hsid__experts hsid__experts--one">' +
            '<figure class="hsid__expert">' +
              '<span class="hsid__expert-mark" aria-hidden="true">' + ICONS.quote + '</span>' +
              '<blockquote>' + esc(plan.freeExpert.text) + '</blockquote>' +
              '<figcaption class="hsid__expert-by">' +
                (portrait ? '<span class="hsid__expert-face">' + portrait.outerHTML + '</span>' : '') +
                '<span>HerLoom Styling Expert</span>' +
              '</figcaption>' +
            '</figure>' +
          '</div>');
      }

      if (plan.freeInsight) {
        html += block('02', 'Why this matters for your hair',
          '<div class="hsid__insights">' +
            '<div class="hsid__insight">' +
              '<h4>' + esc(plan.freeInsight.title) + '</h4>' +
              '<p>' + esc(plan.freeInsight.body) + '</p>' +
              (plan.freeInsight.when
                ? '<div class="hsid__trigger">' + triggerChips(plan.profile, plan.freeInsight.when).map(function (t) {
                    return '<span>' + esc(t) + '</span>';
                  }).join('') + '</div>'
                : '') +
            '</div>' +
          '</div>');
      }

      html += '<div class="hsid__locked">';

      html += lockedBlock('03', 'Your settings', c.settings, 'settings',
        '<div class="hsid__ghost-specs">' + repeat(3, function (i) {
          var w = [[48, 70], [54, 66], [44, 72]][i];
          return '<span class="hsid__ghost-spec">' + ghostLines(w) + '</span>';
        }) + '</div>');

      if (c.insights) {
        html += lockedBlock('04', 'Why this matters for your hair', c.insights,
          c.insights > 1 ? 'more insights' : 'more insight',
          '<div class="hsid__ghost-stack">' + repeat(c.insights, function () {
            return '<span class="hsid__ghost-card">' + ghostLines([88, 96, 62]) + '</span>';
          }) + '</div>');
      }

      html += lockedBlock('05', 'Your attachment order', c.attachments,
        c.attachments > 1 ? 'attachments' : 'attachment',
        '<div class="hsid__ghost-atts">' + repeat(c.attachments, function () {
          return '<span class="hsid__ghost-att">' + ghostLines([70, 90]) + '</span>';
        }) + '</div>');

      html += lockedBlock('06', 'Your standard routine', c.routine, 'steps',
        '<div class="hsid__ghost-stack">' + repeat(Math.min(c.routine, 6), function () {
          return '<span class="hsid__ghost-row">' + ghostLines([92, 58]) + '</span>';
        }) + '</div>');

      html += lockedBlock('07', 'Mistakes to avoid', c.mistakes,
        c.mistakes > 1 ? 'mistakes' : 'mistake',
        '<div class="hsid__ghost-stack">' + repeat(c.mistakes, function () {
          return '<span class="hsid__ghost-row">' + ghostLines([86, 64]) + '</span>';
        }) + '</div>');

      if (c.care) {
        html += lockedBlock('08', 'Care notes', c.care, c.care > 1 ? 'notes' : 'note',
          '<div class="hsid__ghost-stack">' + repeat(c.care, function () {
            return '<span class="hsid__ghost-row">' + ghostLines([80, 52]) + '</span>';
          }) + '</div>');
      }

      html += '</div>';

      var total = c.settings + c.insights + c.attachments + c.routine + c.mistakes + c.care;
      html += '<div class="hsid__unlock">' +
        '<span class="hsid__unlock-icon" aria-hidden="true">' + ICONS.lock + '</span>' +
        '<h3 class="hsid__unlock-title">' + esc(CFG.lockTitle || 'The rest of your plan is ready') + '</h3>' +
        '<p class="hsid__unlock-count">' + total + ' more items written for this exact profile</p>' +
        (CFG.lockText ? '<p class="hsid__unlock-text">' + esc(CFG.lockText) + '</p>' : '') +
        (CFG.lockCtaUrl
          ? '<a class="hsid__btn hsid__unlock-btn" href="' + esc(CFG.lockCtaUrl) + '">' +
            esc(CFG.lockCtaLabel || 'Get my HerLoom') + '</a>'
          : '') +
        (CFG.lockNote ? '<p class="hsid__unlock-note">' + esc(CFG.lockNote) + '</p>' : '') +
        '<button type="button" class="hsid__btn hsid__btn--ghost" data-restart>Retake the quiz</button>' +
      '</div>';

      mountR.innerHTML = html;

      var unlock = mountR.querySelector('.hsid__unlock-btn');
      if (unlock) unlock.addEventListener('click', function () {
        track('unlock_click', { goal: plan.profile.goal, locked_items: total });
        flushTrack(true);
      });

      var restart = mountR.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', function () {
        track('restart');
        reset();
      });
    }

    function renderResult(plan) {
      var p = plan.profile;
      var faces = expertFaces();
      var offset = faceOffset(plan.code || '');
      var hero = libNode('[data-goal-image][data-key="' + p.goal + '"] img');
      var html = '';

      html += '<div class="hsid__card">' +
        (hero ? '<div class="hsid__card-hero">' + hero.outerHTML + '</div>' : '') +
        '<p class="hsid__eyebrow" data-owner>Your HerLoom Style ID</p>' +
        (ownerName ? '<p class="hsid__owner">' + esc(ownerName) + '</p>' : '') +
        '<h2 class="hsid__card-title">' + esc(plan.name) + '</h2>' +
        '<div class="hsid__tags">' + plan.chips.map(function (t) {
          return '<span class="hsid__tag">' + esc(t) + '</span>';
        }).join('') + '</div>' +
        (plan.shade
          ? '<p class="hsid__shade"><span class="hsid__shade-dot" style="background:' + plan.shade.hex + '"></span>' +
            esc(plan.shade.label) + '</p>'
          : '') +
        '<p class="hsid__code">Profile ' + esc(plan.code) + '</p>' +
      '</div>';

      html += '<dl class="hsid__specs">' +
        '<div class="hsid__spec hsid__spec--heat" data-heat="' + esc(plan.heat.value) + '">' +
          '<dt>Heat</dt>' +
          '<dd><span class="hsid__heat-dot" aria-hidden="true"></span>' + esc(plan.heat.value) + '</dd>' +
          '<small>' + esc(plan.heat.reason) + '</small></div>' +
        '<div class="hsid__spec"><dt>Slice size</dt><dd>' + esc(plan.sectionSize) + '</dd>' +
          '<small>How much hair you pick up in one pass, front and back.</small></div>' +
        '<div class="hsid__spec"><dt>Sections to clip</dt><dd>' + esc(plan.zones) + '</dd>' +
          '<small>How many bundles you pin up before switching the device on.</small></div>' +
      '</dl>';

      html += block('01', 'HerLoom Expert Notes',
        '<div class="hsid__experts">' + plan.expert.map(function (e, i) {
          var portrait = faces.length ? faces[(offset + i) % faces.length] : null;
          return '<figure class="hsid__expert">' +
            '<span class="hsid__expert-mark" aria-hidden="true">' + ICONS.quote + '</span>' +
            '<blockquote>' + esc(e.text) + '</blockquote>' +
            '<figcaption class="hsid__expert-by">' +
              (portrait ? '<span class="hsid__expert-face">' + portrait.outerHTML + '</span>' : '') +
              '<span>HerLoom Styling Expert</span>' +
            '</figcaption>' +
          '</figure>';
        }).join('') + '</div>');

      html += block('02', 'Why this matters for your hair',
        '<div class="hsid__insights">' + plan.insights.map(function (n) {
          var chips = triggerChips(p, n.when);
          return '<article class="hsid__insight">' +
            '<h4>' + esc(n.title) + '</h4>' +
            '<p>' + esc(n.body) + '</p>' +
            (chips.length ? '<div class="hsid__trigger">' + chips.map(function (c) {
              return '<span>' + esc(c) + '</span>';
            }).join('') + '</div>' : '') +
          '</article>';
        }).join('') + '</div>');

      html += block('03', 'Your attachment order',
        '<ol class="hsid__atts">' + plan.attachments.map(attachmentCard).join('') + '</ol>');

      html += block('04', plan.routine.title,
        '<p class="hsid__q-help" style="margin-bottom:16px">' + esc(plan.routine.note) + '</p>' +
        '<ol class="hsid__list">' + plan.routine.steps.map(function (s, i) {
          return '<li><span class="hsid__marker">' + String(i + 1).padStart(2, '0') + '</span>' +
            '<span>' + esc(s.t) + '</span></li>';
        }).join('') + '</ol>');

      html += block('05', 'Mistakes to avoid',
        '<ul class="hsid__list hsid__list--avoid">' + plan.mistakes.map(function (m) {
          return '<li><span class="hsid__marker">' + ICONS.cross + '</span><span>' + esc(m.text) + '</span></li>';
        }).join('') + '</ul>');

      if (plan.care.length) {
        html += block('06', 'Care notes',
          '<ul class="hsid__list hsid__list--care">' + plan.care.map(function (c) {
            return '<li><span class="hsid__marker">' + ICONS.shield + '</span><span>' + esc(c.text) + '</span></li>';
          }).join('') + '</ul>');
      }

      html += '<div class="hsid__actions">' +
        '<button type="button" class="hsid__btn" data-print>' + ICONS.print + 'Save my plan</button>' +
        '<button type="button" class="hsid__btn hsid__btn--ghost" data-copy>' + ICONS.copy + 'Copy summary</button>' +
        '<button type="button" class="hsid__btn hsid__btn--ghost" data-restart>Retake the quiz</button>' +
      '</div>';

      if (CFG.supportUrl) {
        html += '<div class="hsid__support">' +
          '<h3>' + esc(CFG.supportTitle || 'Still need help with your first style?') + '</h3>' +
          '<p>' + esc(CFG.supportText || 'Send us your order number, the attachment you used and what happened.') + '</p>' +
          '<a class="hsid__btn" href="' + esc(CFG.supportUrl) + '?style_id=' + encodeURIComponent(plan.code) + '">' +
          ICONS.life + 'Get personalised help</a>' +
        '</div>';
      }

      html += '<p class="hsid__disclaimer">' + esc(CFG.disclaimer ||
        'These are styling suggestions based on the answers you gave, not medical or professional hair advice. Your heat setting is a starting point, not a prescription. Always follow the safety instructions in your HerLoom manual, and if your hair has had a chemical treatment, follow your stylist’s aftercare first.') +
      '</p>';

      mountR.innerHTML = html;

      var printBtn = mountR.querySelector('[data-print]');
      if (printBtn) printBtn.addEventListener('click', function () {
        track('print');
        window.print();
      });

      var copyBtn = mountR.querySelector('[data-copy]');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        track('copy');
        var text = summaryText(plan);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(
            function () { flash('Summary copied'); },
            function () { flash('Could not copy — select the text instead'); });
        } else { flash('Copying is not supported in this browser'); }
      });

      var restart = mountR.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', reset);
    }

    /* The attachment turns on its own, but nothing downloads until the
       card is really on screen. */
    var spinObserver = null;

    function initSpinners() {
      var spinners = mountR.querySelectorAll('.hsid__att-media.has-video');
      if (!spinners.length) return;
      root.classList.add('hsid--autospin');

      var start = function (wrap) {
        var v = wrap.querySelector('video');
        if (!v) return;
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        wrap.classList.add('is-spinning');
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () { wrap.classList.remove('is-spinning'); });
      };

      if (!('IntersectionObserver' in window)) { spinners.forEach(start); return; }

      if (spinObserver) spinObserver.disconnect();
      spinObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) { start(entry.target); } else { v.pause(); }
        });
      }, { rootMargin: '150px 0px' });

      spinners.forEach(function (el) { spinObserver.observe(el); });
    }

    function summaryText(plan) {
      var lines = [];
      lines.push('HerLoom Style ID — ' + plan.name + ' (' + plan.code + ')');
      lines.push(plan.chips.join(' / '));
      lines.push('');
      lines.push('Heat: ' + plan.heat.value + ' — ' + plan.heat.reason);
      lines.push('Section size: ' + plan.sectionSize);
      lines.push('Sections to clip: ' + plan.zones);
      lines.push('Attachments: ' + plan.attachments.map(function (a) { return a.name; }).join(' > '));
      lines.push('');
      lines.push(plan.routine.title + ':');
      plan.routine.steps.forEach(function (s, i) { lines.push((i + 1) + '. ' + s.t); });
      lines.push('');
      lines.push('Mistakes to avoid:');
      plan.mistakes.forEach(function (m) { lines.push('- ' + m.text); });
      if (plan.care.length) {
        lines.push('');
        lines.push('Care notes:');
        plan.care.forEach(function (c) { lines.push('- ' + c.text); });
      }
      return lines.join('\n');
    }

    /* ---- Persistence ---- */

    function save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          v: 3, answers: answers, name: ownerName, at: Date.now()
        }));
      } catch (e) {}
    }

    function load() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.answers) return null;
        if (typeof data.name === 'string') ownerName = data.name;
        var complete = QUESTIONS.every(function (q) { return !!data.answers[q.id]; });
        return complete ? data.answers : null;
      } catch (e) { return null; }
    }

    function reset() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      answers = {};
      index = 0;
      shadeFamilyOpen = null;
      renderQuestion();
      show('quiz');
    }

    /* ---- Wiring ---- */

    root.querySelectorAll('[data-start]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track('start');
        openDoors(function () {
          index = 0;
          renderQuestion();
          show('quiz');
        });
      });
    });

    if (backBtn) backBtn.addEventListener('click', back);
    bindNameScreen();

    track('view');

    var saved = load();
    if (saved && welcome) {
      welcome.hidden = false;
      var viewBtn = welcome.querySelector('[data-view-saved]');
      if (viewBtn) viewBtn.addEventListener('click', function () {
        track('resume');
        openDoors(function () {
          answers = saved;
          renderPlanScreen();
          show('result');
          requestAnimationFrame(initSpinners);
        });
      });
    }

    renderQuestion();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hsid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
